// Shared business-scope predicate.
//
// Keep this symmetric with backend/routes/businesses.py :: global_or. A
// business carrying ANY of these markers serves every country and must pass
// every region/country filter — otherwise a global service (e.g. Bitrefill)
// disappears for a user filtered to a specific region/country.
//
// Backend global_or markers (businesses.py):
//   { service_area: 'global' }
//   { region: 'global' }
//   { service_scope_type: 'global' }
//   { service_scope: 'global' }
//
// Used by Directory.js, BusinessMapCountry.js, BusinessMapRegion.js so all
// three surfaces stay in lock-step with the backend.
export function isGlobalScope(b) {
  if (!b) return false;
  return (
    b.service_scope === 'global' ||
    b.service_area === 'global' ||
    b.service_scope_type === 'global' ||
    (b.region || '').toLowerCase() === 'global'
  );
}

export default isGlobalScope;
